export default __webpack_public_path__ + "static/media/infoIllustration6.5d2976a4.gif";